import { createContext, useContext } from "react";
import invariant from "tiny-invariant";
import type { VotingSessionContextValue } from "./VotingSessionProvider";

export const VotingSessionContext = createContext<VotingSessionContextValue | null>(null);

export function useVotingSession() {
  const context = useContext(VotingSessionContext);
  invariant(context, "`useVotingSession` must be used within a `VotingSessionProvider`");
  return context;
}
